import Header from "../header/Header";
import Footer from "../footer/Footer";
import "./resourcesPage.scss";
import { ChevronRightCircle } from "@styled-icons/boxicons-solid/ChevronRightCircle";
import { PopularResourcesSection } from "../../components";
import { VerticalCard } from "../../components";
import { API_CONSTANTS, EXTERNAL_SITE_LINKS } from "../../types/constants";

const ResourcesPage = () => {
  const sideCards = [
    {
      title: "State agency workforce and salary data. ",
      url: "https://youtu.be/9VXxbEG7JY0?si=_aYYPErd4MeMrXN0",
      imgsrc:
        "https://sco-loctrans-images.s3.us-gov-west-1.amazonaws.com/ui-images/sco-ui-state-agency-workforce.png",
    },
    {
      title: "Townhall Idaho Public Meeting Portal.",
      url: "https://youtu.be/xT2_SEF2uOc?si=LPSfcB3UhqtfRJfC",
      imgsrc:
        "https://sco-loctrans-images.s3.us-gov-west-1.amazonaws.com/ui-images/sco-ui-townhall-public-meeting-portal.png",
    },
    {
      title: "Filter reports on Transparent Idaho. ",
      url: "https://youtu.be/GEvSpTxeXKc?si=QKGkEdRrQ4klA27M",
      imgsrc:
        "https://sco-loctrans-images.s3.us-gov-west-1.amazonaws.com/ui-images/sco-ui-filter-reports-transparent-idaho.png",
    },
  ];

  return (
    <div>
      <header>
        <Header />
      </header>
      <main>
        <div className="landing-page-container">
          <div className="resources-page-hero-section">
            <div className="featured-resources">
              <div className="content">
                <h2>Introducing Transparent Idaho</h2>
                <p>
                  Explore our featured resources showcasing state transparency
                  in action, highlighting openness, accountability, and public
                  access to government data.
                </p>
                <a
                  href={EXTERNAL_SITE_LINKS.FEATURED_RESOURCES}
                  target="_blank"
                  className="read-more"
                >
                  <p>Read More</p>
                </a>
                <ChevronRightCircle
                  className="readmore-icon"
                  size="20px"
                  color="#FFFFFF"
                />
              </div>
            </div>
            <div className="hero-section-side-cards">
              {sideCards.map((card, index) => (
                <div className="side-card" key={card.title + index}>
                  <div className="side-card-icon">
                    <img
                      src={card.imgsrc}
                      alt="Hero"
                      className="side-card-image"
                      loading="lazy"
                    />
                  </div>
                  <div className="side-card-text">
                    <h6>{card.title}</h6>
                    <div
                      className="button-see-more-text"
                      onClick={() => {
                        window.open(card.url, "_blank");
                      }}
                      tabIndex={0}
                      aria-label="See more"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          window.open(card.url, "_blank");
                        }
                      }}
                    >
                      <p>See More</p>
                      <ChevronRightCircle
                        className="readmore-icon"
                        size="20px"
                        color="#404E65"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="resources-quick-links-section ">
            <PopularResourcesSection
              links={[
                {
                  imgSrc: `${API_CONSTANTS.imageBucket}/ui-images/sco-ui-insight-idaho.png`,
                  imgAlt: "Insight Idaho",
                  title: "Insight Idaho",
                  pageUrl: EXTERNAL_SITE_LINKS.INSIGHT_IDAHO,
                },
                {
                  imgSrc: `${API_CONSTANTS.imageBucket}/ui-images/sco-ui-central-registry.png`,
                  imgAlt: "Central Registry",
                  title: "Central Registry",
                  pageUrl: EXTERNAL_SITE_LINKS.CENTRAL_REGISTRY,
                },
                {
                  imgSrc: `${API_CONSTANTS.imageBucket}/ui-images/sco-ui-townhall-idaho.png`,
                  imgAlt: "Townhall Idaho",
                  title: "Townhall Idaho",
                  pageUrl: EXTERNAL_SITE_LINKS.TOWNFALL_IDAHO,
                },
                {
                  imgSrc: `${API_CONSTANTS.imageBucket}/ui-images/sco-ui-surplus-property.png`,
                  imgAlt: "Surplus Property",
                  title: "Surplus Property",
                  pageUrl: EXTERNAL_SITE_LINKS.SURPLUS_PROPERTY,
                },
              ]}
            />
          </div>
          <div className="resources-page-card-section app-padding">
            <div tabIndex={0} aria-label="Other Resources section">
              <div className="home-page-title-container">
                <h2 className="title">Other Resources</h2>
              </div>
              <p className="body-large resources-page-header-description">
                Below you will find interactive reports for budgets, fund
                balances, salaries and more. See information next to reports for
                helpful descriptions and insights.
              </p>
            </div>
            <div className="more-high-level-cards cards">
              <VerticalCard
                cardTitle="Newspaper Association of Idaho"
                cardDescription="Details on the activites of local, count, and state governments, along with updates from local and state courts."
                cardTag=""
                image={
                  API_CONSTANTS.imageBucket +
                  "/ui-images/sco-ui-newspaper-association-of-idaho.png"
                }
                readMoreText="See More"
                readMoreAction={() => {
                  window.open(
                    EXTERNAL_SITE_LINKS.NEWSPAPER_ASSOCIATION_IDAHO,
                    "_blank"
                  );
                }}
              />
              <VerticalCard
                cardTitle="Vote Idaho"
                cardDescription="The Secretary of State's Election Division provides campaign finance voter guides, election results, and much more. "
                cardTag=""
                image={
                  API_CONSTANTS.imageBucket + "/ui-images/sco-ui-vote-idaho.png"
                }
                readMoreText="See More"
                readMoreAction={() => {
                  window.open(EXTERNAL_SITE_LINKS.VOTE_IDHAO, "_blank");
                }}
              />
              <VerticalCard
                cardTitle="Neighbor State's Transparency Pages"
                cardDescription="Learn about transparency efforts in our neighboring States."
                image={
                  API_CONSTANTS.imageBucket +
                  "/ui-images/sco-ui-neighbor-states.png"
                }
                cardTag=""
                readMoreText="See More"
                readMoreAction={() => {
                  window.open(
                    EXTERNAL_SITE_LINKS.NEIGHBOR_TRANSPARENCY_PAGES,
                    "_blank"
                  );
                }}
              />
            </div>
            <div className="more-high-level-cards">
              <VerticalCard
                cardTitle="Associated Taxpayers of Idaho"
                cardDescription="The Associated Taxpayers of Idaho is an indpendent, nonpartisan, nonprofit organization dedicated to advocating for Idaho's taxpayers."
                image={
                  API_CONSTANTS.imageBucket +
                  "/ui-images/sco-ui-associated-taxpayers.png"
                }
                readMoreText="See More"
                readMoreAction={() => {
                  window.open(
                    EXTERNAL_SITE_LINKS.ASSOCIATED_TAXPAYERS_IDAHO,
                    "_blank"
                  );
                }}
              />
              <VerticalCard
                cardTitle="Division of Financial Management"
                cardDescription="DFM assists the Governor in his duties as the Chief Budget Officer of the State."
                cardTag=""
                image={
                  API_CONSTANTS.imageBucket +
                  "/ui-images/sco-ui-division-financial-management.png"
                }
                readMoreText="See More"
                readMoreAction={() => {
                  window.open(
                    EXTERNAL_SITE_LINKS.DIVISION_OF_FACILITIES_MANAGEMENT,
                    "_blank"
                  );
                }}
              />
              <VerticalCard
                cardTitle="Legislative Services Office"
                cardDescription="The Budget and Policy Analysis Division of the Idaho Legislature provides independent, non-partisan analytical support to the legislature in the budget setting."
                cardTag=""
                image={
                  API_CONSTANTS.imageBucket +
                  "/ui-images/sco-ui-legislative-services.png"
                }
                readMoreText="See More"
                readMoreAction={() => {
                  window.open(
                    EXTERNAL_SITE_LINKS.DIVISION_OF_FACILITIES_MANAGEMENT,
                    "_blank"
                  );
                }}
              />
            </div>
          </div>
        </div>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
export default ResourcesPage;
